var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMailBlock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "communication/outline/mail_block"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 9",
    cx: 18.1667,
    cy: 6.5,
    r: 4,
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 26",
    d: "M15.1667 3.5L21.1667 9.5",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 105",
    d: "M5.91675 13.5L8.11675 15.15C9.18341 15.95 10.6501 15.95 11.7167 15.15L13.9167 13.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9167 12.4536V19.5C18.9167 21.5711 17.2378 23.25 15.1667 23.25H5.16675C3.09568 23.25 1.41675 21.5711 1.41675 19.5V11.5C1.41675 9.42893 3.09568 7.75 5.16675 7.75H12.2971C12.4093 8.27911 12.5911 8.78247 12.8327 9.25H5.16675C3.92411 9.25 2.91675 10.2574 2.91675 11.5V19.5C2.91675 20.7426 3.92411 21.75 5.16675 21.75H15.1667C16.4094 21.75 17.4167 20.7426 17.4167 19.5V12.4536C17.6624 12.4842 17.9128 12.5 18.1667 12.5C18.4207 12.5 18.6711 12.4842 18.9167 12.4536Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailBlock);
export default __webpack_public_path__ + "static/media/mail_block.30bd3d5166f64c63fe41fdbd00e7d3c6.svg";
export { ForwardRef as ReactComponent };